import React from 'react';

import Router from 'next/router';
import { FeedActivityItem } from '@components/Feed/Activities/FeedActivityItem';
import { PostGroupItem } from '@components/Feed/Activities/Types/Post/PostGroupItem';
import { PostDropdown } from '@components/Feed/Post/Dropdown';
import { useAuth } from '@context/auth/base';
import type {
  FragmentType,
  PostGroupItemFragmentDoc,
  UserActivityDetailFragmentDoc,
} from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { webappUriPath } from '@utils/url';

export function PostItem({
  post,
  timeStamp,
  webappUri,
  postId,
  creator,
}: {
  post: FragmentType<PostGroupItemFragmentDoc>;
  timeStamp: number;
  webappUri: string;
  postId: string;
  creator: FragmentType<UserActivityDetailFragmentDoc> & { id: string };
}) {
  const { authUser } = useAuth();

  return (
    <div
      className="-m-3 cursor-pointer rounded-lg p-3 hover:bg-neutral50 hover:[&_.read-more-button]:bg-neutral200 [&_.read-more-overlay]:hover:from-neutral50"
      data-feed-clickable-div
      onClick={e => {
        if (e.target instanceof HTMLElement) {
          if (e.target.hasAttribute('data-feed-clickable-div')) {
            Router.push(webappUriPath(webappUri));

            trackClickEvent({
              event: 'Post Link Clicked',
              properties: {
                associationId: postId,
                associationType: 'Post',
                sourceComponent: 'Feed Post',
              },
            });
          }
        }
      }}
    >
      <FeedActivityItem
        userFrag={creator}
        description="Posted"
        timestamp={timeStamp}
        dropdownContent={
          creator.id === authUser?.id || authUser?.roles?.isAdmin ? (
            <PostDropdown postId={postId} creatorUserId={creator.id} />
          ) : null
        }
        isPost
      >
        <PostGroupItem postFrag={post} />
      </FeedActivityItem>
    </div>
  );
}
